export default "__VITE_ASSET__Bz6uUez3__"